<template>
  <div class="page-table-box" ref="tableBox" v-loading="loading">
    <v-table ref="table"
      :class="{'table-no-data': data.length === 0}"
      :error-content-height="emptyHeight"
      :height="tableHeight"
      :is-vertical-resize="isVerticalResize"
      is-horizontal-resize
      style="width:100%;"
      :columns="col"
      :table-data="data"
      :row-height="rowHeight"
      :title-rows="titleRows"
      :title-row-height="titleRowHeight"
      :odd-bg-color="oddColor"
      :even-bg-color="evenColor"
      :row-hover-color="hoverColor"
      :show-vertical-border="showVerticalBorder"
      :show-horizontal-border="showHorizontalBorder"
      @on-custom-comp="compFn"
      :vertical-resize-offset='hasFixed ? 128 : showPage ? 70 : 40'
      :select-all="selectAll"
      :select-change="selectChange"
      :titleIconMouseEnter="titleIconMouseEnter"
      :titleIconMouseLeave="titleIconMouseLeave"
      :cell-merge="cellMerge"
      :footer="footer"
      :footer-row-height="footerHeight"
      :cell-edit-done="cellEditDone"
    ></v-table>
    <v-pagination
      v-if="showPage && data.length !== 0 && !loading"
      @page-change="pageChange"
      @page-size-change="pageSizeChange"
      :total="total"
      :pageSizeOption="[30, 50, 100]"
      :page-size="pageSize"
      :page-index="pageIndex"
      :layout="['sizer', 'prev', 'pager', 'next']"
    ></v-pagination>
  </div>
</template>

<script>
import '@/components/vue-easytable/themes-base/index.css'
import { VTable, VPagination } from '@/components/vue-easytable'

export default {
  components: { VTable, VPagination },
  data() {
    return {
      emptyHeight: 300
    }
  },
  props: {
    loading: Boolean,
    col: Array,
    data: Array,
    footer: Array,
    total: Number,
    titleRows: Array,
    hoverColor: {
      type: String
    },
    pageSize: {
      type: Number,
      default: 30
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    showPage: {
      type: Boolean,
      default: true
    },
    hasFixed: {
      type: Boolean,
      default: false
    },
    tableHeight: Number,
    noDataHeight: {
      type: Number,
      default: 300
    },
    rowHeight: {
      type: Number,
      default: 32
    },
    titleRowHeight: {
      type: Number,
      default: 50
    },
    footerHeight: Number,
    showTrBack: {
      type: Boolean,
      default: true
    },
    isVerticalResize: {
      type: Boolean,
      default: true
    },
    showVerticalBorder: {
      type: Boolean,
      default: false
    },
    showHorizontalBorder: {
      type: Boolean,
      default: false
    },
    cellMerge: Function,
    selectAll: Function,
    selectChange: Function,
    titleIconMouseEnter: Function,
    titleIconMouseLeave: Function
  },
  computed: {
    oddColor() {
      if (!this.showTrBack) {
        return '#FFFFFF'
      } else {
        if (this.titleRows === undefined || this.titleRows.length === 0) {
          return '#FFFFFF'
        } else {
          return '#F3F6F8'
        }
      }
    },
    evenColor() {
      if (!this.showTrBack) {
        return '#FFFFFF'
      } else {
        if (this.titleRows === undefined || this.titleRows.length === 0) {
          return '#F3F6F8'
        } else {
          return '#FFFFFF'
        }
      }
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        this.$refs.table.$el.querySelector('.v-table-header').scrollLeft = 0
        this.$refs.table.$el.querySelector('.v-table-body').scrollLeft = 0
        this.$refs.table.$el.querySelector('.v-table-body').scrollTop = 0
        this.resize()
      })
    }
  },
  mounted() {
    if (this.hasFixed) {
      this.emptyHeight = window.innerHeight - (this.$refs.tableBox.offsetTop + 90 + 70 + 123)
    } else {
      this.emptyHeight = this.noDataHeight
    }
  },
  methods: {
    resize() {
      this.$refs.table.resize()
    },
    pageChange(page) {
      this.$emit('pageChange', page)
    },
    pageSizeChange(pageSize) {
      this.$emit('pageSizeChange', pageSize)
    },
    compFn(params) {
      this.$emit('compFn', params)
    },
    // 清除选择
    clearSelect() {
      this.$nextTick(() => {
        this.$refs.table && (this.$refs.table.isAllChecked = false)
      })
    },
    cellEditDone(newValue, oldValue, rowIndex) {
      this.$emit('cell_edit_done', newValue, oldValue, rowIndex)
    }
  }
}
</script>
